/* Índice de contenidos del artículo: genera anclas a partir de los h2 del
   contenido migrado y marca el apartado activo al hacer scroll. */
(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  function init() {
    var toc = document.querySelector('.mm-article__toc');
    var content = document.querySelector('.mm-article__body .article-template__content');
    if (!toc || !content) return;

    var list = toc.querySelector('.mm-article__toc-list');
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < 2) return;

    var used = {};
    var links = headings.map(function (heading) {
      var base = heading.id || slugify(heading.textContent || 'seccion');
      var id = base;
      var n = 2;
      while (used[id]) { id = base + '-' + n++; }
      used[id] = true;
      heading.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });

    toc.hidden = false;
    // Abierto en escritorio (lista fija), plegado en móvil.
    var desktop = window.matchMedia('(min-width: 990px)');
    var syncOpen = function () { toc.open = desktop.matches; };
    syncOpen();
    if (desktop.addEventListener) desktop.addEventListener('change', syncOpen);

    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          links.forEach(function (a) {
            a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
          });
        });
      },
      { rootMargin: '-10% 0px -75% 0px', threshold: 0 }
    );
    headings.forEach(function (h) { observer.observe(h); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
